<template>
  <div class="upload-image-container">
    <van-uploader
      v-model="fileList"
      :max-count="maxCount"
      :max-size="maxSize"
      :accept="accept"
      :disabled="disabled"
      @oversize="onOversize"
      :after-read="afterRead"
      @delete="handleDelete"
    >
      <template v-if="!hasImage">
        <div class="upload-placeholder">
          <van-icon name="plus" />
          <span>上传</span>
        </div>
      </template>
      <van-image v-else :src="imageUrl" fit="cover" class="uploaded-image" />
      <div v-if="uploading" class="uploading-overlay">
        <van-loading type="spinner" />
      </div>
    </van-uploader>
  </div>
</template>

<script>
import { uploadImage } from "@/service/api/index";
import { Toast } from "vant";

export default {
  name: "UploadImage",
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    // 双向绑定的图片URL
    modelValue: {
      type: String,
      default: "",
    },
    // 最大上传数量
    maxCount: {
      type: Number,
      default: 1,
    },
    // 最大文件大小（字节），默认10MB
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1000,
    },
    // 允许的文件类型
    accept: {
      type: String,
      default: "image/*",
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 宽度
    width: {
      type: [Number, String],
      default: "100px",
    },
    // 高度
    height: {
      type: [Number, String],
      default: "100px",
    },
  },
  data() {
    return {
      fileList: [],
      uploading: false,
    };
  },
  computed: {
    hasImage() {
      return this.modelValue && this.modelValue.length > 0;
    },
    imageUrl() {
      return this.modelValue;
    },
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.fileList = [{ url: newVal }];
        } else {
          this.fileList = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    afterRead(file) {
      this.uploading = true;
      // 创建FormData，将文件添加进去（二进制）
      const formData = new FormData();
      formData.append("file", file.file);

      // 调用上传接口 POST /component/upload/image
      uploadImage(formData)
        .then((res) => {
          if (res.code === 200 && res.data) {
            // 接口返回的data就是图片URL，直接赋值
            this.$emit("update:modelValue", res.data);
            this.$emit("success", res.data);
            Toast.success("上传成功");
          } else {
            Toast.fail(res.message || "上传失败");
            this.$emit("error", res);
          }
        })
        .catch((error) => {
          console.error("图片上传错误:", error);
          Toast.fail("上传失败，请重试");
          this.$emit("error", error);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    handleDelete() {
      this.$emit("update:modelValue", "");
      this.$emit("delete");
    },
    onOversize() {
      const maxSizeMB = this.maxSize / (1024 * 1000);
      Toast.fail(`文件大小不能超过 ${maxSizeMB}MB`);
    },
  },
};
</script>
<style lang="less" scoped>
.upload-image-container {
  .van-uploader {
    width: v-bind(width);
    height: v-bind(height);

    ::v-deep .van-uploader__wrapper {
      width: 100%;
      height: 100%;
    }

    .van-uploader__input-wrapper {
      width: 100%;
      height: 100%;
    }
  }

  .upload-placeholder {
    width: 6rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    color: #999;
    font-size: 12px;

    .van-icon {
      font-size: 20px;
      margin-bottom: 4px;
    }
  }

  .uploaded-image {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .uploading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }
}
</style>
